import React from 'react'

type Props = {
  decisionMaker: string
}

export const DecisionMakerDisplay: React.FC<Props> = ({decisionMaker}) => {
  if (!decisionMaker) return <span>-</span>

  const getInitials = (name: string) => {
    const nameParts = name.split(' ')
    return `${nameParts[0].charAt(0).toUpperCase()}`
  }

  return (
    <div className='d-flex align-items-center'>
      <div className='symbol symbol-25px me-5'>
        <span
          className='symbol-label fs-7 fw-bold'
          style={{backgroundColor: '#F5F5F5', border: '1px solid #E5E5E5'}}
        >
          {getInitials(decisionMaker)}
        </span>
      </div>
      <div className='d-flex justify-content-start flex-column'>
        <span className='text-dark fw-bold text-hover-primary fs-7'>{decisionMaker}</span>
      </div>
    </div>
  )
}
